<template>
  <div>
    <div class="visually-hidden hidden-media-print-visible">
      <h3>
        {{ printHeading }}
      </h3>
      <h4 id="bibliography-list-aria">
        {{ ariaHeading }}
      </h4>
      <br />
    </div>
    <ul aria-labelledby="bibliography-list-aria">
      <BibliographyItem
        v-for="(value, key) in bibliography"
        v-bind="value"
        :key="key"
        type="li"
      />
    </ul>
  </div>
</template>

<script>
import { useLocalization } from "@thegetty-private/getty-ui";
import BibliographyItem from "@/components/atoms/bibliographyItem/index.vue";

export default {
  name: "BibliographyList",
  components: {
    BibliographyItem
  },

  props: {
    /**
     * The bibliography data from the store
     */
    bibliography: {
      required: true,
      type: Array,
      default: () => []
    }
  },
  setup(props) {
    return {
      ...useLocalization({
        baseLocaleKey: props?.baseLocaleKey
      })
    };
  },

  data() {
    return {
      /**
       * The aria heading for the component
       */
      ariaHeading: this.translatePart("bibliography_list.ariaHeading"),
      /**
       * The heading displayed on just the print style sheet
       */
      printHeading: this.translatePart(
        "human_made_object_tabs.bibliographyTabName"
      )
    };
  }
};
</script>

<style lang="scss">
@import "./index.scss";
</style>
